// src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthContext';
import ThemeProvider from './context/ThemeProvider';
import { OrderNotificationProvider } from './context/OrderNotificationContext';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

if ('serviceWorker' in navigator && 'PushManager' in window) {
  window.addEventListener('load', async () => {
    const reg = await navigator.serviceWorker.register('/sw.js');

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return;

    const existing = await reg.pushManager.getSubscription();
    if (!existing) {
      const sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: 'BBAolOIwoAuJAdK24ov4ck5t9Bd_Rdg2cCQ40ujSy1htJCWPdCnU4NHlGDf8IqiSi40hEPthkZTZbWiK4USARD8',
      });

      await fetch('/api/push/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ subscription: sub }),
      });
    }
  });
}


root.render(
  <React.StrictMode>
        <OrderNotificationProvider>

    <ThemeProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ThemeProvider>
    </OrderNotificationProvider>
  </React.StrictMode>
);

reportWebVitals();
